import React, { useEffect, useState } from "react";
import { Select, SelectProps } from "@RooUI";

import { MediaSourceOption } from "./hooks/useMediaSourceOptions";
import { fetchMediaSourceOptions } from "./service";

interface HearAboutRooSelectProps
  extends Omit<SelectProps<MediaSourceOption>, "options" | "value"> {
  value?: number;
}

export const HearAboutRooSelect = (props: HearAboutRooSelectProps) => {
  const [mediaSourceOptions, setMediaSourceOptions] = useState<MediaSourceOption[]>([]);

  useEffect(() => {
    const fetchOptions = async () => {
      const options = await fetchMediaSourceOptions();
      setMediaSourceOptions(options);
    };

    fetchOptions();
  }, []);

  return (
    // @ts-expect-error TS2322
    <Select
      label={props.label || "Source"}
      options={mediaSourceOptions}
      placeholder="Please select one"
      {...props}
      {...(props.value !== undefined && { value: props.value })}
    />
  );
};
